import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../../config/firebaseConfig";
import { FaTimes } from "react-icons/fa";
import "./UserAvailabilitySettings.css";

const UserAvailabilitySettings = ({
  isOpen,
  onClose,
  sectionId,
  courseId,
  editingUser,
}) => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(editingUser?.userId || null);
  const [startDate, setStartDate] = useState(
    editingUser ? new Date(editingUser.startDate) : null
  );
  const [endDate, setEndDate] = useState(
    editingUser ? new Date(editingUser.endDate) : null
  );
  const [userAvailability] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [saveMessage, setSaveMessage] = useState("");

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const getClassListDataFunction = httpsCallable(
          functions,
          "getClassListData"
        );
        const result = await getClassListDataFunction();
        setUsers(result.data.students);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();
  }, []);

  const handleSaveUserAvailability = async () => {
    if (!selectedUser || !startDate || !endDate) {
      setSaveMessage("Please fill in all fields");
      return;
    }

    setIsSaving(true);
    setSaveMessage("");

    try {
      const updateUserAvailabilityFunction = httpsCallable(
        functions,
        "updateUserAvailability"
      );
      await updateUserAvailabilityFunction({
        courseId,
        sectionId,
        userId: selectedUser,
        availability: {
          startDate: startDate.toISOString(),
          endDate: endDate.toISOString(),
        },
      });

      setSaveMessage("User availability updated successfully");
      onClose();
    } catch (error) {
      console.error("Error updating user availability:", error);
      setSaveMessage(`Error: ${error.message}`);
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    if (!editingUser && selectedUser && userAvailability[selectedUser]) {
      const startDateStr = userAvailability[selectedUser].startDate;
      const endDateStr = userAvailability[selectedUser].endDate;

      setStartDate(startDateStr ? new Date(startDateStr) : null);
      setEndDate(endDateStr ? new Date(endDateStr) : null);
    }
  }, [selectedUser, userAvailability, editingUser]);

  return (
    <div className="user-availability-modal">
      <div className="user-availability-content">
        <button className="close-button" onClick={onClose}>
          <FaTimes />
        </button>
        <h3>User-Specific Availability</h3>
        <div className="user-select">
          <select
            value={selectedUser || ""}
            onChange={(e) => setSelectedUser(e.target.value)}
          >
            <option value="">Select a user</option>
            {users.map((user) => (
              <option key={user.id} value={user.id}>
                {user.displayName || user.email}
              </option>
            ))}
          </select>
        </div>
        {selectedUser && (
          <div className="date-picker-container">
            <div className="date-field">
              <label>Available From:</label>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                showTimeSelect
                dateFormat="MMMM d, yyyy h:mm aa"
                placeholderText="Select start date and time"
                className="date-input"
              />
            </div>
            <div className="date-field">
              <label>Available Until:</label>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                showTimeSelect
                dateFormat="MMMM d, yyyy h:mm aa"
                placeholderText="Select end date and time"
                className="date-input"
                minDate={startDate}
              />
            </div>
            <button
              className="save-button"
              onClick={handleSaveUserAvailability}
            >
              Save User Settings
            </button>
          </div>
        )}
        {isSaving && <p>Saving...</p>}
        {saveMessage && <p>{saveMessage}</p>}
      </div>
    </div>
  );
};

export default UserAvailabilitySettings;
